import { listStyles } from "@insite/content-library/Widgets/MyLists/MyListsList";
import { GridOffset } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

Object.assign(listStyles, {
    cardList: {
        gridContainer: {
            gap: 0,
            css: css`
                margin: 0;

                ${GridOffset} {
                    width: 100%;
                }
            `,
        },
    },
});
